module.exports = __webpack_public_path__ + "img/it-6.c1e2ce20.png";